'use client';
import { useState, useEffect } from 'react';
import { BaseModal } from '../BaseModal/BaseModal';
import { Button } from '../../Buttons/Button/Button';
import { AuthInput } from '../../Inputs/AuthInput/AuthInput';
import { useToast } from '../../Toasts/ToastContainer';
import styles from './ForgotPasswordModal.module.css';

interface ForgotPasswordModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
	userEmail?: string;
}

export const ForgotPasswordModal = ({
	isOpen,
	onClose,
	onSuccess,
	userEmail = '',
}: ForgotPasswordModalProps) => {
	const [email, setEmail] = useState(userEmail);
	const [isLoading, setIsLoading] = useState(false);
	const toast = useToast();

	useEffect(() => {
		if (isOpen) setEmail(userEmail);
	}, [isOpen, userEmail]);

	const handleSend = async () => {
		if (!email.trim()) {
			toast.error('Digite um endereço de e-mail válido');
			return;
		}

		setIsLoading(true);
		try {
			await new Promise((resolve) => setTimeout(resolve, 800));
			toast.success('E-mail de recuperação enviado com sucesso!');
			if (onSuccess) {
				onSuccess();
			} else {
				onClose();
			}
		} catch {
			toast.error('Erro ao enviar e-mail de recuperação. Tente novamente.');
		} finally {
			setIsLoading(false);
		}
	};

	const handleClose = () => {
		setEmail(userEmail);
		setIsLoading(false);
		onClose();
	};

	return (
		<BaseModal
			isOpen={isOpen}
			onClose={handleClose}
			title="Recuperar Senha"
			isLoading={isLoading}
			actions={
				<>
					<Button
						variant="cancel"
						onClick={handleClose}
						disabled={isLoading}
						type="button"
						className={styles.actionButton}
					>
						Voltar
					</Button>
					<Button
						variant="primary"
						onClick={handleSend}
						isLoading={isLoading}
						disabled={isLoading}
						type="button"
						className={styles.actionButton}
					>
						Enviar link
					</Button>
				</>
			}
		>
			<div className={styles.content}>
				<p className={styles.description}>
					Enviaremos um link de redefinição de senha para o e-mail abaixo. Verifique sua caixa de
					entrada após o envio.
				</p>
				<div className={styles.inputWrapper}>
					<AuthInput
						label="E-mail"
						type="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						placeholder="seu@email.com"
						disabled={isLoading}
					/>
				</div>
			</div>
		</BaseModal>
	);
};
